"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_dom_1 = require("react-dom");
var fallback = function (context, node) {
    if (node) {
        do {
            if (node === context)
                return true;
        } while ((node = node.parentNode));
    }
    return false;
};
exports.canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.contains = (function () {
    return exports.canUseDom
        ? function (context, node) {
            if (!node)
                return false;
            if (context.contains) {
                return context.contains(node);
            }
            if (context.compareDocumentPosition) {
                //16 is used to check if compareDocumentPosition also returned 16, which means that 'node' is positioned INSIDE 'context'
                return context === node || !!(context.compareDocumentPosition(node) & 16);
            }
            return fallback(context, node);
        }
        : fallback;
})();
exports.getContainer = function (container, defaultContainer) {
    if (container == null)
        return defaultContainer;
    container = typeof container === 'function' ? container() : container;
    return react_dom_1.default.findDOMNode(container) || null;
};
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/dialog/build/utils.js
// module id = 608
// module chunks = 0